module.exports = __webpack_public_path__ + "static/img/8.2e66471.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/eng/8.png
// module id = 1MkZ
// module chunks = 0